import { useState } from 'react';
import 'semantic-ui-less/semantic.less'
import './stylesheets/App.css';
import AScene from './react-components/AScene.js'
import OverlayUI from './react-components/OverlayUI.js'
import { createMedia } from '@artsy/fresnel'
import hotspotList from './data/hotspot_list.json'

export const { MediaContextProvider, Media } = createMedia({
    breakpoints: {
      mobile: 0,
      tablet: 800,
      computer: 1371
    },
})

window.componentsInitialized = 0;
window.debug = false;

const App = () => {
  const [hotspots, setHotspots] = useState(hotspotList)
  const [isSceneLoaded, setIsSceneLoaded] = useState(false)
  const isMobile = false

  const onSceneLoaded = () => {
    // console.log("onSceneLoaded");
    let cameraEl = document.getElementById("cam");
    cameraEl.setAttribute('look-controls', 'reverseMouseDrag: false; reverseTouchDrag: true;');
    cameraEl.setAttribute('wasd-controls', 'enabled: false');
    cameraEl.setAttribute('animation__fadeoutzoom', "startEvents: fadeoutzoom; property: camera.zoom; from: 1; to: 2; dur: 1000; easing: easeInOutQuad; loop: 2; dir: alternate;");
    setIsSceneLoaded(true);
  }

  return (
    <div className="App">
      <AScene hotspotList={hotspots} sceneLoaded={onSceneLoaded}/>
      <OverlayUI hotspots={hotspots} isMobile={isMobile} isSceneLoaded={isSceneLoaded}/>
    </div>
  );
}

export default App;
